import type { TFunction } from 'i18next'

import { paymentOptionLabels } from '#/entities/shipment'

// Compact terms abbreviations for the order-summary card (e.g. "COD").
const TERMS_SHORT_KEYS: Record<string, string> = {
  cash_on_delivery: 'carrierRequests.termsCod',
  cash_on_pickup: 'carrierRequests.termsCop',
}

/**
 * Turns the shipment's raw payment vocabulary (`cash`, `cash_on_delivery`)
 * into the display parts shown in the order summary — e.g. ["Cash", "COD"].
 */
export function formatPaymentParts(
  t: TFunction,
  method: string | undefined,
  terms: string | undefined,
): string[] {
  const labels = paymentOptionLabels(t)
  const methodLabel = labels.method(method)
  const termsKey = terms != null ? TERMS_SHORT_KEYS[terms] : undefined
  const termsLabel = termsKey != null ? t(termsKey) : labels.terms(terms)
  return [methodLabel, termsLabel].filter((part): part is string =>
    Boolean(part),
  )
}
